import React from 'react';
import { CiLocationOn } from "react-icons/ci";

import './introsection.scss'

const IntroSection = () =>
{
	return (
		<>
			<div className="intro-section-container">
				<section className="sub-intro-section">

					<div className="intro-content">

						<div className="tag-group">
							<span className="tag">❄️ AC Rooms</span>
							{/* <span className="tag">📶 Free WiFi</span> */}
							<span className="tag">🅿️ Parking</span>
							{/* <span className="tag">🛋️ Fully Furnished</span> */}
						</div>

						<h1 className="main-title">
							Saiful – 2BHK Home Stay
						</h1>

						<div className="IntroSectionlocation">
							<CiLocationOn className="icon" />
							<span>Saiful (Near Bijapur Road) Solapur, Maharashtra, India</span>
						</div>

					</div>

					<div className="price-badge">
						<p className="label">Price per Night</p>
						<p className="IntroSectionprice">
							₹2,500*<span>/night</span>{" "} <span>(Upto 5 People*)</span>
						</p>
					</div>

				</section>
			</div>
		</>
	);
};

export default IntroSection;